import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_2 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "w-full max-w-[700px] relative flex justify-center p-[20px] items-center" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "flex md:justify-between justify-center flex-wrap items-center relative w-full" }
const _hoisted_6 = { class: "md:w-[47%] w-full my-[10px] text-left" }
const _hoisted_7 = {
  for: "name",
  class: "text-black block font-bold uppercase text-sm"
}
const _hoisted_8 = { class: "md:w-[47%] w-full my-[10px] text-left" }
const _hoisted_9 = {
  for: "email",
  class: "text-black block font-bold uppercase text-sm"
}
const _hoisted_10 = { class: "flex md:justify-between justify-center flex-wrap items-center relative w-full" }
const _hoisted_11 = { class: "md:w-[47%] w-full my-[10px] text-left" }
const _hoisted_12 = {
  for: "phone",
  class: "text-black block font-bold uppercase text-sm"
}
const _hoisted_13 = { class: "md:w-[47%] w-full my-[10px] text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "objet",
  class: "text-black block font-bold uppercase text-sm"
}, "Objet*", -1)
const _hoisted_15 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_16 = { class: "w-full my-[10px] text-left" }
const _hoisted_17 = {
  for: "projet",
  class: "text-black block font-bold uppercase text-sm"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "(Optionel)", -1)
const _hoisted_19 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_20 = { class: "w-full my-[10px] text-left" }
const _hoisted_21 = {
  for: "description",
  class: "text-black block font-bold uppercase text-sm"
}
const _hoisted_22 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_23 = { class: "w-full flex my-[10px] text-left items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "agree",
  id: "agree",
  required: ""
}, null, -1)
const _hoisted_25 = {
  for: "agree",
  class: "mx-[10px] text-black block font-bold uppercase text-sm"
}
const _hoisted_26 = { class: "flex justify-between items-center relative w-full" }
const _hoisted_27 = { class: "w-full flex my-[20px] justify-end" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_30 = { key: 1 }

import axios from 'axios'
import { ref } from 'vue'
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  setup(__props) {

const name = ref('');
const email = ref('');
const phone = ref('');
const subject = ref('');
const project = ref('');
const message = ref('');
const loading = ref(false);
const successMessage = ref('');
const errorMessage = ref('');

const contact = () => {
  loading.value = true;

  axiosInstance.post('/contact-us/', {
    fullname: name.value,
    email: email.value,
    phone_number: phone.value,
    subject: subject.value,
    project: project.value,
    message: message.value,
  })
  .then(response => {
    loading.value = false;

    if (response.status === 200 || response.status === 201 || response.status === 201) {
      successMessage.value = 'Message envoyé avec succès !';
      hideSuccessMessageAfterDelay();
      clearForm();
    } else {
      successMessage.value = '';
    }
  })
  .catch(error => {
    loading.value = false;
    console.error(error);
    errorMessage.value = 'Une erreur s\'est produite. Veuillez réessayer.';
    hideErrorMessageAfterDelay();
  });
};

const hideSuccessMessageAfterDelay = () => {
  setTimeout(() => {
    successMessage.value = ''; 
  }, 5000);
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

const clearForm = () => {
  name.value = '';
  email.value = '';
  phone.value = '';
  subject.value = '';
  message.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "w-full relative",
        onSubmit: _withModifiers(contact, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('c_name')) + "*", 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              id: "name",
              placeholder: "Nom",
              class: "w-full p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, name.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('c_email')) + "*", 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
              id: "email",
              placeholder: "Email",
              class: "w-full p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('c_phone')) + "*", 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phone).value = $event)),
              id: "phone",
              placeholder: "Téléphone",
              class: "w-full p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, phone.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subject).value = $event)),
              id: "objet",
              placeholder: "Objet",
              class: "w-full p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, subject.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t('c_project')) + " ", 1),
              _hoisted_18
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((project).value = $event)),
              id: "projet",
              placeholder: "Projet",
              class: "w-full p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, project.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('c_description')) + "*", 1),
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((message).value = $event)),
              id: "description",
              placeholder: "Description",
              class: "w-full h-[200px] resize-none p-[5px] border border-gray-900 outline-none focus:border-blue-500"
            }, null, 512), [
              [_vModelText, message.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('c_agree')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "rounded-[5px] min-w-[150px] bg-cyan-500 text-white p-[10px]"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('c_send')), 1))
            ], 8, _hoisted_28)
          ])
        ])
      ], 40, _hoisted_4)
    ])
  ], 64))
}
}

})